export default "images/车灯开启情况-自动大灯.png";